import React, { useState, useEffect, useRef } from "react";

const useFadeOnCenter = (ref) => {
  const [opacity, setOpacity] = useState(0);

  useEffect(() => {
    function handleScroll() {
      if (!ref.current) return;
      const rect = ref.current.getBoundingClientRect();
      const elemCenter = rect.top + rect.height / 2;
      const windowCenter = window.innerHeight / 2;
      const dist = Math.abs(elemCenter - windowCenter);
      const fadeDistance = window.innerHeight / 2; // fade out at top/bottom

      // Opacity: 1 at center, 0 at top/bottom
      let newOpacity = 1 - dist / fadeDistance;
      newOpacity = Math.max(0, Math.min(1, newOpacity));
      setOpacity(newOpacity);
    }
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, [ref]);

  return opacity;
};
export default useFadeOnCenter;
